export enum DocumentType {
  SUBSCRIPTION_DOCUMENT = 'SUBSCRIPTION_DOCUMENT',
}
